import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  0% {
    transform: scale(0.25);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const StyledImageLoaded = styled.picture`
  visibility: ${props =>
    props.isLoaded === true || props.isError === false ? 'visible' : 'hidden'};
  animation: ${props =>
    props.home === true && props.isLoaded === true
      ? css`
          ${fadeIn} 2s linear
        `
      : css`
          ${fadeIn} 0 linear
        `};
  transition: ${props =>
    props.home === true
      ? css`
      visibility 2s linear
    `
      : css`
      visibility 1s linear
    `};
`;
